var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row items-center justify-end full-width"},[_c('action-show-button',{staticClass:"max-width-100",attrs:{"url":_vm.depositBankAccountShowPageLink,"label":"مشاهده"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }